import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import HashScrollHandler from "@/components/HashScrollHandler";
import AnnouncementChyron from "@/components/AnnouncementChyron";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import ATFQPodcast from "@/components/ATFQPodcast";
import Investigations from "@/components/Investigations";
import About from "@/components/About";
import SitDownSurvey from "@/components/SitDownSurvey";
import Footer from "@/components/Footer";
import ScoutPage from "@/pages/ScoutPage";
import VoicesPage from "@/pages/VoicesPage";
import CalendarPage from "@/pages/CalendarPage";
import NextRecordingStrip from "@/components/atfq/NextRecordingStrip";
import AuthCallback from "@/components/AuthCallback";
import { AuthProvider } from "@/lib/auth";

const Landing = () => {
  return (
    <main className="bg-white text-[var(--navy)] min-h-screen">
      <AnnouncementChyron />
      <Nav />
      <Hero />
      <NextRecordingStrip />
      <ATFQPodcast />
      <Investigations />
      <About />
      <SitDownSurvey />
      <Footer />
    </main>
  );
};

const AppRouter = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <HashScrollHandler />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/scout" element={<ScoutPage />} />
        <Route path="/voices" element={<VoicesPage />} />
        <Route path="/calendar" element={<CalendarPage />} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
